import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getOrders(query) {
    return RetailerApiClient.get('orders', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrder(orderId) {
    return RetailerApiClient.get('orders/' + orderId).then(response => {
      return response
    })
  },
  getPromissoryNote(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/promissory-note', {
      'axios-retry': {
        retries: 5,
        retryDelay: retryCount => {
          return retryCount * 1000
        }
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesContract(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/sales-contract', {
      'axios-retry': {
        retries: 5,
        retryDelay: retryCount => {
          return retryCount * 1000
        }
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getTransportationDocument(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/transportation-document', {
      'axios-retry': {
        retries: 5,
        retryDelay: retryCount => {
          return retryCount * 1000
        }
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getInvoice(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/invoice', {
      'axios-retry': {
        retries: 5,
        retryDelay: retryCount => {
          return retryCount * 1000
        }
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrderReceipt(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/order-receipt', {
      'axios-retry': {
        retries: 5,
        retryDelay: retryCount => {
          return retryCount * 1000
        }
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCropEquivalentContract(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/crop-equivalent-contract', {
      'axios-retry': {
        retries: 5,
        retryDelay: retryCount => {
          return retryCount * 1000
        }
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRepaymentSchedule(orderId) {
    return RetailerApiClient.get(`orders/${orderId}/repayment-schedule`, {
      'axios-retry': {
        retries: 5,
        retryDelay: retryCount => {
          return retryCount * 1000
        }
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCreditAgreement(orderId) {
    return RetailerApiClient.get(`orders/${orderId}/credit-agreement`, {
      'axios-retry': {
        retries: 5,
        retryDelay: retryCount => {
          return retryCount * 1000
        }
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewInvoice(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/public-invoice', {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewPromissoryNote(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/public-promissory-note', {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewSalesContract(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/public-sales-contract', {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewTransportationDocument(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/public-transportation-document', {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewFarmerTransportationDocument(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/public-farmer-transportation-document', {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewOrderReceipt(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/public-order-receipt', {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewCropEquivalentContract(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/public-crop-equivalent-contract', {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewRepaymentSchedule(orderId) {
    return RetailerApiClient.get(`orders/${orderId}/public-repayment-schedule`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewCreditAgreement(orderId) {
    return RetailerApiClient.get(`orders/${orderId}/public-credit-agreement`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewCreditApplication(orderId) {
    return RetailerApiClient.get(`orders/${orderId}/public-credit-application`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewPromissoryNoteAndOrderReceipt(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/public-promissory-note-and-order-receipt', {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewFibaDocument(params) {
    return RetailerApiClient.get(`orders/${params.orderId}/public-fibabanka-document/${params.type}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  confirm(orderId) {
    return RetailerApiClient.post('orders/' + orderId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  resendOTP(id, phone, farmerId, otpType, isResend) {
    return RetailerApiClient.post('orders/' + id + '/resend-otp', {
      phone: phone,
      farmer_id: farmerId,
      otp_type: otpType,
      is_resend: isResend
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getWorkflowJobs(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/workflow-jobs')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createWorkflowJob(orderId, workflowId, params) {
    return RetailerApiClient.post('orders/' + orderId + '/workflow-jobs/' + workflowId + '/toggle', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getWorkflowJobAnswers(orderId, workflowId) {
    return RetailerApiClient.get('orders/' + orderId + '/workflow-jobs/' + workflowId + '/answers')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  destroy(id, params) {
    return RetailerApiClient.delete('orders/' + id, {
      data: params
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendPaymentLink(orderId) {
    return RetailerApiClient.post(`orders/${orderId}/send-credit-card-payment-link`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerProductPrices(orderId) {
    return RetailerApiClient.get('orders/' + orderId + '/retailer-product-prices')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateRetailerProductPrices(orderId, payload) {
    return RetailerApiClient.post('orders/' + orderId + '/retailer-product-prices', payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  async saveMortgageContractItem(itemId, payload) {
    return RetailerApiClient.patch(`mortgage-contract-items/${itemId}`, payload)
  },
  async viewMortgageContractItemDocument(itemId) {
    return RetailerApiClient.get(`mortgage-contract-items/${itemId}/view-document`, {
      responseType: 'arraybuffer'
    })
  }
}
